import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { myProjectsTeamsTimesheetsActions } from "store/my-project-teams-timesheet-waiting";
import { projectActions } from "store/project/project.slice";

const useProjectManagerWaittingHook = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const mainColor = useSelector((state) => state.appConfiguration.mainColor);
  const activeKey = params.setting;
  let {
    myProjectsTeamsTimesheetswaiting: { allProjectsTimesheets, selectedProject, loading }
  } = useSelector((state) => state);
  
 
  useEffect(() => {
    // TODO: Remove getAll request dispatch once back is ready
    
      
      dispatch(myProjectsTeamsTimesheetsActions.getAllProjectsTeamsTimesheets());
    
    return () => {
      dispatch(myProjectsTeamsTimesheetsActions.clearSelectedItems());
    };
  }, []);

  useEffect(() => {
    if (allProjectsTimesheets.length > 0) {
      dispatch(myProjectsTeamsTimesheetsActions.setSelectedProject(allProjectsTimesheets[0].project.id));
    }
  }, [allProjectsTimesheets]);

  return { loading, dispatch, activeKey, dispatch, allProjectsTimesheets, selectedProject, mainColor };
};

export default useProjectManagerWaittingHook;
